jQuery(document).ready(function() {
    jQuery(document).on('click', '.mad-blog-posts__load-more-btn', function(e) {
        e.preventDefault();
        var $btn = jQuery(this);
        var nextPage = parseInt($btn.data('next-page'));
        var uniqueId = $btn.data('unique-id');
        var $container = $btn.closest('.mad-blog-posts__container[data-count]');
        var $grid = $container.find('.mad-blog-posts');
        var shortcodeAtts = $container.data('shortcode-atts') || {};
        if (!shortcodeAtts.count) {
            shortcodeAtts.count = parseInt($container.data('count')) || 10;
        }
        console.log('Load more button clicked:', {
            nextPage: nextPage,
            uniqueId: uniqueId,
            shortcodeAtts: shortcodeAtts
        });
        shortcodeAtts.current_page = nextPage;
        shortcodeAtts.load_more = 'true';
        jQuery.ajax({
            url: window.$madSettings.blogPosts.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'mad_blog_posts_load_more',
                nonce: window.$madSettings.blogPosts.nonce,
                page: nextPage,
                shortcode_atts: JSON.stringify(shortcodeAtts),
                container_id: uniqueId
            },
            beforeSend: function() {
                $btn.prop('disabled', true).addClass('loading');
            },
            success: function(response) {
                var data = response.data || response;
                if (response.success && data.html) {
                    console.log('Load more posts:', data);
                    // Fallback: strip duplicate CDN prefix (e.g. https://cdn.x.de/https://cdn.x.de/...)
                    var html = data.html.replace(/(https?:\/\/[^/'"]+)\/(https?:\/\/)/g, '$2');
                    $btn.closest('.mad-blog-posts__load-more-wrapper').remove();
                    $grid.append(html);
                }
            },
            complete: function() {
                $btn.prop('disabled', false).removeClass('loading');
            }
        });
    });
});
